import { tooltip } from './_base';

const Morale = () => {
  let value = 0;

  return {
    value,
    label: 'Morale',
    tooltip: gameState => tooltip('morale', gameState),
    min: 0,
    max: 100
  };
};

export default Morale;
